import React, { useMemo } from "react";
import PropTypes from "prop-types";

import EventTimesheetTab from "../../../../components/Events/Event/timesheet/EventTimesheetTab";
import { ExportTimesheetModal } from "../../../../components/Events/Event/timesheet/modals";
import useCompanyEventTimesheet from "./useCompanyEventTimesheet";

const CompanyEventTimesheetTab = ({ event }) => {
  const companyTimesheet = useCompanyEventTimesheet(event);

  const integration = useMemo(
    () => ({
      ...companyTimesheet,
      showExportAll: false,
    }),
    [companyTimesheet],
  );

  return (
    <>
      <EventTimesheetTab
        event={event}
        integration={integration}
        selectedApplicantId={companyTimesheet.selectedApplicantId}
        onApplicantSelect={companyTimesheet.setSelectedApplicantId}
      />
      <ExportTimesheetModal
        open={companyTimesheet.isExportModalOpen}
        loading={companyTimesheet.isExporting}
        onClose={companyTimesheet.onExportModalClose}
        onConfirm={companyTimesheet.onExportConfirm}
      />
    </>
  );
};

CompanyEventTimesheetTab.propTypes = {
  event: PropTypes.object,
};

CompanyEventTimesheetTab.defaultProps = {
  event: null,
};

export default CompanyEventTimesheetTab;
